// Busca por destino do Hub. A mesma lista alimenta o campo do topo da Central
// e o diálogo da lupa da barra superior, para os dois acharem o mesmo.
//
// Um destino pode aparecer no mapa de mais de uma área: os relatórios moram
// dentro da área que medem e também no mundo Medir, que fica sem card. Sem
// isto a pessoa via a mesma tela repetida, uma linha por área. A chave é o
// alvo de verdade (rota, params e query), e vence a primeira área da ordem
// do mapa, que é a mais específica.
const targetKey = destination =>
  JSON.stringify([
    destination.routeName,
    destination.params || null,
    destination.query || null,
  ]);

export const matchHubDestinations = (worlds, query, translate) => {
  const term = String(query || '')
    .trim()
    .toLocaleLowerCase();
  const seen = new Set();
  return (worlds || [])
    .flatMap(world =>
      (world.destinations || []).map(destination => ({
        ...destination,
        key: `${world.id}:${destination.id}`,
        label: destination.label || translate(destination.labelKey),
        worldLabel: translate(world.labelKey),
      }))
    )
    .filter(destination =>
      `${destination.label} ${destination.worldLabel}`
        .toLocaleLowerCase()
        .includes(term)
    )
    .filter(destination => {
      const key = targetKey(destination);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};
